import React, { useContext } from 'react';
import { PartiesContext } from '../../context/PartiesContext';
import { Button } from 'react-bootstrap';

export const PatyFormDelete = () => {
  const { toggleDeleteParty, currentPartyItem, handleDelete, values, setValues } =
    useContext(PartiesContext);
  const { party_data = {}, full_name = '', name = '' } = currentPartyItem;
  const resolvedName =
    `${party_data.names || full_name || name} ${party_data.paternal_surname || ''} ${party_data.maternal_surname || ''}`.trim();

  return (
    <>
      <div className="">
        <h5>¿Estás seguro de eliminar la parte?</h5>
        <p>{resolvedName}</p>
      </div>
      <div className="mt-2 d-flex justify-content-between">
        <Button variant="dark" onClick={toggleDeleteParty}>
          Cancelar
        </Button>

        <Button variant="danger" onClick={handleDelete}>
          Eliminar
        </Button>
      </div>
    </>
  );
};
